import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, budget }) =>
    present(
      repository
        .updateProjectAllocatedBudget(project, budget)
        .then(() => ({ project, budget }))
        .catch(() => Promise.reject({ project, budget })),
    );
}

export type { Interactor };

export { createInteractor };
